export default __webpack_public_path__ + "static/media/plus-icon-with-black-bg.18c867bd.svg";